import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const sintomas = [
  { text: "La persiana no sube o sube a tirones" },
  { text: "La cinta se atasca o se sale del recogedor" },
  { text: "Hace ruido chirriante al subir o bajar" },
  { text: "Se descarrila y las lamas se desalinean" },
];

const steps = [
  { num: "1", title: "Diagnóstico gratis", desc: "Identificamos si es la cinta, el recogedor o el cajón. Sin coste." },
  { num: "2", title: "Desmontaje del cajón", desc: "Accedemos al interior de la persiana con cuidado para no dañar nada." },
  { num: "3", title: "Sustitución cinta + comprobación", desc: "Colocamos cinta nueva de calidad y revisamos todo el mecanismo." },
  { num: "4", title: "Montaje y prueba", desc: "Volvemos a montar y probamos que sube y baja perfectamente. Garantía incluida." },
];

const diy = [
  { label: "DIY (tú mismo)", items: ["Riesgo de romper el recogedor", "Necesitas herramientas específicas", "Puede llevarte varias horas", "Sin garantía si falla"], highlight: false },
  { label: "Técnico profesional", items: ["Diagnóstico exacto en minutos", "Herramientas y repuestos incluidos", "Terminado en menos de 1 hora", "Garantía 2 años incluida"], highlight: true },
];

const faqs = [
  {
    q: "¿Cuánto cuesta cambiar una cinta de persiana en Málaga?",
    a: "Nuestro servicio de cambio de cinta cuesta entre 60 y 90 € todo incluido: mano de obra, cinta nueva y revisión del mecanismo. Sin sorpresas ni costes ocultos.",
  },
  {
    q: "¿Cuánto tardáis en venir?",
    a: "Normalmente acudimos en menos de 24 horas. Si es urgente, intentamos el mismo día. Llámanos y te confirmamos disponibilidad al instante.",
  },
  {
    q: "¿Qué tipo de cinta ponéis?",
    a: "Usamos cintas de polipropileno de alta resistencia, disponibles en varios colores para que combine con tu persiana. También tenemos cintas reforzadas para uso intensivo.",
  },
  {
    q: "¿Dais garantía?",
    a: "Sí, todas nuestras reparaciones tienen garantía de 2 años. Si la cinta se rompe o el mecanismo falla, volvemos sin coste.",
  },
  {
    q: "¿Trabajáis con persianas de comunidad?",
    a: "Por supuesto. Reparamos persianas de viviendas particulares, locales comerciales y comunidades de vecinos en toda la Costa del Sol.",
  },
];

export default function CambiarCinta() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Cambiar Cinta Persiana Málaga | Desde 60€ con Garantía"
        description="Cambiamos cintas de persiana en Málaga. Servicio rápido desde 60€. Todos los modelos. Garantía 2 años. ☎ 951 12 07 70"
        canonical="/persianas/cambiar-cinta-persiana/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Persianas", path: "/persianas" }, { name: "Cambiar cinta persiana" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[60%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> 24h · Respuesta en 20 min
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Cambiar Cinta de Persiana en Málaga | Desde 60€
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Servicio rápido y económico. Sustituimos cintas rotas, deshilachadas o atascadas en cualquier modelo.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> +10 años · desde 2015</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Seguro RC</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 2 años</span>
                </div>
              </div>
              <div className="w-full lg:w-[40%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1631084650668-5e1f72bf6ce5?w=1200&q=80&auto=format&fit=crop"
                    alt="Cambiar cinta de persiana en Málaga - servicio profesional"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* SÍNTOMAS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-4">Síntomas de cinta rota</h2>
            <p className="font-body text-lg text-text-secondary text-center mb-10 max-w-2xl mx-auto">
              Si notas alguno de estos signos, es hora de cambiar la cinta antes de que se rompa del todo.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
              {sintomas.map((s, i) => (
                <motion.div
                  key={s.text}
                  className="flex items-center gap-3 bg-white rounded-2xl px-6 py-5 shadow-sm"
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                >
                  <span className="flex items-center justify-center w-8 h-8 bg-primary/10 text-primary rounded-full shrink-0 font-bold text-sm">!</span>
                  <span className="font-body text-base text-text-primary">{s.text}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* PROCESO */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Nuestro proceso paso a paso</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {steps.map((s, i) => (
                <motion.div
                  key={s.num}
                  className="relative text-center"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center font-heading font-extrabold text-2xl mx-auto mb-4">
                    {s.num}
                  </div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{s.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{s.desc}</p>
                  {i < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-8 left-[calc(50%+2rem)] right-[-50%] h-0.5 bg-border"></div>
                  )}
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* PRECIO + DIY VS PRO */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
              {/* Precio */}
              <div>
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Precio orientativo</h2>
                <p className="font-body text-lg text-text-secondary mb-6">
                  Cambiar la cinta de una persiana estándar cuesta entre <strong className="text-text-primary">60 y 90 €</strong>, mano de obra incluida.
                </p>
                <div className="bg-white rounded-3xl p-8 shadow-sm">
                  <div className="flex items-center justify-between mb-4 pb-4 border-b border-border">
                    <span className="font-body text-base text-text-primary">Cambio de cinta estándar</span>
                    <span className="font-heading font-bold text-xl text-primary">60 - 90 €</span>
                  </div>
                  <ul className="flex flex-col gap-2">
                    {["Diagnóstico gratuito", "Cinta nueva de calidad", "Revisión del recogedor", "Mano de obra incluida", "Garantía 2 años"].map((item, i) => (
                      <li key={i} className="flex items-center gap-2 font-body text-sm text-text-secondary">
                        <span className="text-green-600">✓</span> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* DIY vs Pro */}
              <div>
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">¿Lo soluciono yo o llamo a un técnico?</h2>
                <p className="font-body text-lg text-text-secondary mb-6">
                  Cambiar una cinta parece sencillo, pero un error puede dañar el recogedor y encarecer la reparación.
                </p>
                <div className="flex flex-col gap-4">
                  {diy.map((d, i) => (
                    <motion.div
                      key={d.label}
                      className={`rounded-3xl p-6 ${d.highlight ? "bg-text-primary text-white" : "bg-white shadow-sm"}`}
                      initial={{ opacity: 0, y: 15 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: i * 0.1 }}
                    >
                      <h3 className={`font-heading font-bold text-xl mb-4 ${d.highlight ? "text-white" : "text-text-primary"}`}>{d.label}</h3>
                      <ul className="flex flex-col gap-2">
                        {d.items.map((item, j) => (
                          <li key={j} className="flex items-center gap-2">
                            <span className={`text-sm ${d.highlight ? "text-primary-light" : "text-green-600"}`}>✓</span>
                            <span className={`font-body text-sm ${d.highlight ? "text-slate-300" : "text-text-secondary"}`}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto" itemScope itemType="https://schema.org/FAQPage">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Preguntas frecuentes sobre cambio de cinta</h2>
              <div className="flex flex-col gap-4">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-surface-alt rounded-2xl p-6"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}